var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg042FaceMask = function Svg042FaceMask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M452 182.663v-46.82h-15.439c-33.545 0-70.917-6.68-112.182-20.435-36.914-12.334-100.844-12.334-137.758 0-41.265 13.755-77.637 20.435-111.621 20.435H60v46.82c-34.191 8.364-60 44.716-60 88.18s25.809 79.816 60 88.18v46.82h392v-46.82c34.191-8.364 60-44.716 60-88.18s-25.809-79.816-60-88.18m-422 88.18c0-26.043 12.578-48.034 30-56.314v112.628c-17.422-8.28-30-30.271-30-56.314m332 75H150v-30h212zm0-60H150v-30h212zm0-60H150v-30h212zm90 101.314V214.528c17.422 8.28 30 30.271 30 56.314s-12.578 48.035-30 56.315"
  })));
};
export default Svg042FaceMask;